var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"list_item__container"},[_c('div',{staticClass:"list_item__content list_item__element",class:{ is_last: _vm.isLast }},[_c('div',{staticClass:"list_item__title"},[_vm._t("left")],2)]),_c('div',{staticClass:"list_item__action list_item__element"},[_vm._t("right")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }